import { styled } from '@mui/material'
import { CSSProperties, PropsWithChildren, RefObject } from 'react'
import { colorPalette } from '../../style/colorPalette'
import { useResizableArea } from './hooks/resizableArea'
import { ResizableArea } from '../../components/draggers/ResizableArea'

export const SingleSheetRoot = styled('div')({
  display: 'flex',
  width: '100%',
  height: '100%',
  border: `1px solid ${colorPalette.monotone[2]}`,
  backgroundColor: colorPalette.monotone[0],
})

type MainAreaProps = Pick<CSSProperties, 'width'>
export const MainArea = styled('div')(({ width }: MainAreaProps) => ({
  width,
  height: '100%',
}))
type ResizableMainAreaProps = MainAreaProps & {
  singleSheetRootRef: RefObject<HTMLDivElement>
}
export const ResizableMainArea = ({
  singleSheetRootRef,
  children,
}: PropsWithChildren<ResizableMainAreaProps>) => {
  const { defaultWidth, maxWidth, height } =
    useResizableArea(singleSheetRootRef)
  return (
    <ResizableArea width={defaultWidth} maxWidth={maxWidth} height={height}>
      <MainArea>{children}</MainArea>
    </ResizableArea>
  )
}
export const SideBarArea = styled('div')({
  height: '100%',
  flex: '1 1 0%',
})

export const PanelRoot = styled('div')({
  width: '100%',
  height: '100%',
  overflowY: 'scroll',
})

// サイドバーを持たない単一カラム単票用のスクロール領域。
// 残りの高さをすべて使い、はみ出した分を縦スクロールさせる。
// （二ペイン用の SingleSheetRoot / ResizableMainArea の単一カラム版）
export const SingleColumnSheetArea = styled('div')({
  flex: 1,
  minHeight: 0,
  width: '100%',
  overflowY: 'auto',
  padding: '4px',
  backgroundColor: colorPalette.monotone[1],
})

// 単一カラム単票の基本情報テーブルを収めるボックス。
// 値セルがページ幅いっぱいに間延びしないようテーブル幅を制限する
// （WBSアイテム単票と同程度の密度に合わせる）。
export const SingleColumnSheetBody = styled('div')({
  width: '100%',
  maxWidth: '800px',
  border: `1px solid ${colorPalette.monotone[2]}`,
  backgroundColor: colorPalette.monotone[0],
})
